module.exports = __webpack_public_path__ + "static/img/interactionLive09.246fcba.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/interactionLive09.png
// module id = 421P
// module chunks = 0